import { useState } from 'react';
import { IDrone } from "@drone-parts.garphild.pro/interfaces";
import { Checkbox, Flex } from "antd";

import { useMutation, useQueryClient } from "react-query";
import { updateDroneCheckList } from "../../../queries/drones";
import { BASE_CHECKLIST } from "../../../constants";

interface ICheckListShortProps {
  drone: IDrone;
}


function CheckListShort({ drone }: ICheckListShortProps) {
  const [checkListData, setCheckListData] = useState<any>(BASE_CHECKLIST);

  const queryClient = useQueryClient();

  const droneCheckListMutation = useMutation({
    mutationFn: updateDroneCheckList,
    onSettled: () => {
      queryClient.invalidateQueries('drones');
    }
  });

  const onCheckChange = (index: number, newValue: boolean) => {
    const newCheckListData = [...checkListData];
    newCheckListData[index].value = newValue;
    setCheckListData([...newCheckListData]);
    droneCheckListMutation.mutate({ _id: drone._id, title: newCheckListData[index].title, value: newCheckListData[index].value });
  }
  return (
    <Flex wrap="wrap" gap={2}>
      {checkListData.map((check: any, index: number) => {

        if (check.delimiter) {
          return <div className="delimiter"><div className="delimiterText">{check.title}</div></div>
        }
        const realValue = drone.checklist || [];
        const realCheck = realValue.find((item: any) => item.title === check.title);
        check.value = realCheck?.value || false;

        return (
          <Checkbox
            key={index}
            checked={check.value}
            title={check.title}
            rootClassName={check.value ? 'checked' : 'unchecked'}
            onChange={() => onCheckChange(index, !check.value)}
          />
        )
      })}
    </Flex>
  );
}

export default CheckListShort;
